/**
 * Chuỗi của màn Quản lý License RPA (`/rpa/licenses`) — namespace `rpa.licenses`, `rpa.licenseForm`, `rpa.licenseRenew`,
 * `rpa.userLicense`, `rpa.userLicenseStatus` của web-portal native, đổi sang kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp
 * vào `vi.ts`.
 */
export const viRpaLicense = {
  rpaLicense: {
    moTa: 'Cấp, khoá, gia hạn License theo User OpenCore và quản lý thiết bị đã bind.',
    cap: 'Cấp License',
    kpiTong: 'Tổng User License',
    kpiActive: 'License Active',
    kpiChuaCap: 'Chưa được cấp License',
    kpiSapHet: 'License sắp hết hạn',
    kpiSapHetSub: 'Trong {{so}} ngày tới',
    tim: 'Tìm user / email / khách hàng / Project...',
    locTrangThai: 'Lọc theo trạng thái License',
    moiTrangThai: 'Mọi trạng thái',
    locThietBi: 'Lọc theo thiết bị',
    moiThietBi: 'Mọi thiết bị',
    daBind: 'Đã bind thiết bị',
    chuaBindLoc: 'Chưa bind thiết bị',
    daTai: '{{so}} dòng · gồm cả User OpenCore chưa có License',
    nguon: 'Nguồn: database Native + OpenCore',
    khongTaiUser: 'Không tải được User OpenCore — chỉ hiện User đã có License.',
    rong: 'Chưa có License hay User OpenCore nào',
    rongMoTa: 'Cấp License cho một User OpenCore để User đó đăng nhập FOXAI Client và chạy Workflow được chọn.',
    rongLoc: 'Không có User License nào khớp bộ lọc',
    cotUser: 'User',
    cotProject: 'Khách hàng / Project',
    cotWorkflow: 'Workflow được dùng',
    cotLicense: 'License',
    cotThietBi: 'Thiết bị',
    cotHetHan: 'Ngày hết hạn',
    cotTruyCap: 'Quyền chạy',
    soWorkflow: '{{so}} Workflow',
    vinhVien: 'Không thời hạn',
    chuaGanUser: 'Chưa gắn User',
    chuaBind: 'Chưa bind',
    thietBiKhongDoc: 'Không đọc được',
    xemLicense: 'Xem License',
    kiemQuyen: 'Kiểm quyền OpenCore',
    giaHanNut: 'Gia hạn',
    sua: 'Sửa License',
    dongBo: 'Đồng bộ OpenCore',
    khoa: 'Khoá License',
    moKhoa: 'Mở khoá License',
    thuHoiKhongKhoa: 'License đã thu hồi — không khoá / mở khoá được.',
    resetThietBi: 'Reset thiết bị',
    thuHoi: 'Thu hồi License',
    xoa: 'Xoá License',
    dongBoCanUser: 'License chưa gắn User OpenCore. Chọn User rồi bấm Lưu.',
    daDongBo: 'Đã xác minh thành viên role OpenCore.',
    daDongBoKhongThanhVien: 'Đã đồng bộ: License không còn hiệu lực nên User không nằm trong role License.',
    trangThai: {
      none: 'Chưa cấp',
      pending: 'Chưa được cấp License',
      active: 'Active',
      blocked: 'Bị khoá',
      expired: 'Hết hạn',
      revoked: 'Đã thu hồi',
    },
    loai: {
      limited: 'License Limited',
      limitedNgan: 'Limited',
      limitedMoTa: 'Chỉ xem và chạy các Workflow được chọn.',
      pro: 'License Pro',
      proNgan: 'PRO',
      proMoTa: 'Toàn quyền: xem, chạy, chỉnh sửa và cập nhật các Workflow được chọn.',
    },
    truyCap: {
      running: 'Đang hoạt động',
      syncing: 'Chờ đồng bộ OpenCore',
      syncError: 'Lỗi đồng bộ',
      userDisabled: 'User bị khoá',
      inactive: 'Không hoạt động',
    },
    form: {
      capTieuDe: 'Cấp License',
      suaTieuDe: 'Sửa License',
      gioiThieuCap: 'Chọn User OpenCore, Project OpenRPA và các Workflow User được dùng, chọn loại License rồi đặt thời hạn. Mã License nội bộ do hệ thống tự tạo.',
      gioiThieuSua: 'Sửa User, Workflow được dùng, loại License, thời hạn hoặc trạng thái. Quyền trên OpenCore được cập nhật ngay khi lưu.',
      phanDoiTuong: 'Người dùng & Project',
      phanLoai: 'Loại License',
      phanHan: 'Thời hạn & trạng thái',
      user: 'User OpenCore',
      chonUser: 'Chọn User OpenCore...',
      daCoLicense: '(đã có License)',
      project: 'Project OpenRPA',
      chonProject: 'Chọn Project trên OpenCore...',
      projectGoiY: 'Project lấy trực tiếp từ OpenRPA trên OpenCore. Một Project có thể cấp License cho nhiều User.',
      thieuQuyenProject: 'Cần quyền {{quyen}} để đọc danh sách Project trên OpenCore.',
      projectNhan: '{{ten}} · {{so}} Workflow',
      workflow: 'Workflow User được dùng',
      phamViCu: 'License cũ cấp theo Project: User dùng mọi Workflow của Project đó. Muốn chọn từng Workflow, hãy thu hồi rồi cấp License mới.',
      dangTaiWorkflow: 'Đang tải Workflow của Project...',
      projectMat: 'Không còn thấy Project này trên OpenCore.',
      chonProjectTruoc: 'Chọn Project để hiện danh sách Workflow.',
      projectChuaCoWorkflow: 'Project này chưa có Workflow nào trên OpenCore.',
      daChon: 'Đã chọn {{chon}}/{{tong}} Workflow',
      chonHet: 'Chọn tất cả',
      boChonHet: 'Bỏ chọn tất cả',
      userDaCo: 'User này đã có {{so}} License:',
      ngayHet: 'Ngày hết hạn',
      trangThai: 'Trạng thái',
      vinhVien: 'Không thời hạn / Lifetime',
      ghiChu: 'Ghi chú',
      ghiChuGoiY: 'Ghi chú nội bộ (không bắt buộc)...',
      loiDongBoCu: 'Lần đồng bộ OpenCore trước bị lỗi:',
      chanGoiY: 'License Active: User chỉ xem / chạy được đúng các Workflow đã chọn trên OpenCore.',
      cap: 'Cấp License',
      luu: 'Lưu License',
      loiUser: 'Chọn User OpenCore để cấp License.',
      loiProject: 'Chọn Project OpenRPA.',
      loiWorkflow: 'Chọn ít nhất một Workflow cho User.',
      loiHan: 'Chọn ngày hết hạn hoặc đánh dấu Không thời hạn.',
      loiHanActive: 'License Active phải có ngày hết hạn ở tương lai. Đổi ngày, hoặc chọn trạng thái Chưa được cấp License.',
      loiTrung: 'User này đã có License chưa thu hồi trong Project này. Sửa License đó thay vì cấp mới.',
      daCap: 'Đã cấp License.',
      daCapHongDongBo: 'Đã cấp License; đồng bộ role OpenCore chưa thành công — dùng Đồng bộ OpenCore để thử lại.',
      daLuu: 'Đã lưu License.',
      daLuuHongDongBo: 'Đã lưu License; đồng bộ OpenCore chưa thành công — dùng Đồng bộ OpenCore để thử lại.',
    },
    giaHan: {
      tieuDe: 'Gia hạn License · {{ten}}',
      hienTai: 'Hạn hiện tại: {{ngay}}',
      ngayMoi: 'Ngày hết hạn mới',
      goiY: 'Gia hạn cập nhật License hiện tại, không tạo License mới. License đã hết hạn sẽ tự Active lại.',
      loiThieu: 'Chọn ngày hết hạn mới hoặc đánh dấu Không thời hạn.',
      loiQuaKhu: 'Ngày hết hạn mới phải ở tương lai.',
      nut: 'Gia hạn License',
      xong: 'Đã gia hạn License.',
      xongHongDongBo: 'Đã gia hạn; đồng bộ role OpenCore chưa thành công — dùng Đồng bộ OpenCore để thử lại.',
    },
    quyen: {
      tieuDe: 'Quyền OpenCore · {{ten}}',
      licenseAllowed: 'License còn hiệu lực',
      userFound: 'User còn trên OpenCore',
      roleFound: 'Role License RPA còn trên OpenCore',
      roleMember: 'User nằm trong role License',
      invokeGranted: 'Native ghi đã cấp quyền chạy',
      inSync: 'OpenCore khớp với Native',
      co: 'Có',
      khong: 'Không',
    },
    ngan: {
      user: 'Thông tin User',
      username: 'Username',
      email: 'Email',
      userId: 'OpenCore User ID',
      projectKhach: 'Project / Khách hàng',
      workflow: 'Workflow được dùng ({{so}})',
      khongCoWorkflow: 'Project chưa có Workflow nào.',
      license: 'License',
      trangThai: 'Trạng thái',
      loai: 'Loại License',
      ngayCap: 'Ngày cấp',
      ngayHet: 'Ngày hết hạn',
      ghiChu: 'Ghi chú',
      maNoiBo: 'Mã License nội bộ',
      hienMa: 'Hiện mã',
      anMa: 'Ẩn mã',
      thietBi: 'Thiết bị',
      thietBiKhongDoc: 'Không đọc được danh sách thiết bị. Bấm Làm mới để thử lại.',
      tenMay: 'Tên máy',
      hwid: 'HWID',
      ngayBind: 'Ngày bind',
      lanCuoi: 'Lần cuối hoạt động',
      heDieuHanh: 'Hệ điều hành / Client',
      lichSuMay: 'Lịch sử thiết bị ({{so}})',
      daReset: 'reset lúc {{luc}} bởi {{boi}}',
    },
    xacNhan: {
      khoaTieuDe: 'Khoá License của {{user}}?',
      khoaThan: '{{user}} · {{project}}: User không đăng nhập FOXAI Client được nữa và bị gỡ khỏi role License trên OpenCore. Có thể mở khoá lại bất cứ lúc nào.',
      moKhoaTieuDe: 'Mở khoá License của {{user}}?',
      moKhoaThan: '{{user}} · {{project}}: User đăng nhập Client lại được nếu License còn hạn, và vẫn phải đúng thiết bị đã bind. License đã hết hạn thì phải gia hạn trước.',
      thuHoiTieuDe: 'Thu hồi License của {{user}}?',
      thuHoiThan: '{{user}} · {{project}}: User không đăng nhập Client được nữa và bị gỡ khỏi role License (nếu không còn License active ở Project khác). Bản ghi được giữ làm lịch sử; không mở lại được, nhưng có thể cấp License mới cho User trong Project này.',
      resetTieuDe: 'Reset thiết bị của {{user}}?',
      resetThan: 'Máy {{may}} thôi bind với License. Lần đăng nhập Client tiếp theo sẽ bind vào máy mới; lease offline cũ hết hiệu lực.',
      xoaTieuDe: 'Xoá License của {{user}} ({{project}})?',
      xoaThan: 'License và liên kết thiết bị bị xoá vĩnh viễn, không hoàn tác được; quyền role License của User được gỡ. Không xoá User OpenCore, Project hay Workflow. Muốn tạm dừng thì dùng Khoá License.',
      daKhoa: 'Đã khoá License.',
      daMoKhoa: 'Đã mở khoá License.',
      doiHongDongBo: 'Đã đổi trạng thái License nhưng chưa đồng bộ được role OpenCore — dùng Đồng bộ OpenCore để thử lại.',
      daThuHoi: 'Đã thu hồi License.',
      daReset: 'Đã reset thiết bị. User sẽ bind máy mới ở lần đăng nhập tiếp theo.',
      daXoa: 'Đã xoá License.',
    },
  },
} as const;
